import React from 'react';
import { CSSTransition } from 'react-transition-group';
import CustomInput from '../CustomInput/CustomInput';
import DMSpinnerButton from '../../common/DMSpinnerButton/DMSpinnerButton';
import sendForgotPasswordEmail from '../sendForgotPasswordEmail';

const ForgotPasswordForm = ({ onBack, passwordChange }) => {
    const usernameRef = React.useRef();
    const [userName, setUserName] = React.useState('');
    const [touched, setTouched] = React.useState({});
    const [errors, setErrors] = React.useState({});
    const [loading, setLoading] = React.useState(false);
    const [message, setMessage] = React.useState({ text: '', type: '' }); // type: 'success' or 'error'

    const handleChange = (e) => {
        setUserName(e.target.value);
    };

    const handleBlur = () => {
        setTouched({ username: true });
    };

    const onSendEmail = async () => {
        setLoading(true);

        try {
            const data = await sendForgotPasswordEmail(userName);

            if (data?.data?.forgotPassword?.status) {
                setMessage({
                    text: data.data.forgotPassword.message || 'Email sent successfully!',
                    type: 'success'
                });
            } else {
                setMessage({
                    text: 'Failed to send email. Please try again.',
                    type: 'error'
                });
            }
        } catch (error) {
            console.error('Error sending forgot password request:', error);
            setMessage({
                text: 'An error occurred. Please try again later.',
                type: 'error'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <CSSTransition in={true} timeout={8500} classNames="form-elem-transition" appear>
                <div className='form-header transition-delay'>
                    <span className='login-txt'>{passwordChange ? 'Change Your Password' : "Can't Access Your Account?"}</span>
                </div>
            </CSSTransition>
            <CSSTransition in={true} timeout={8500} classNames="form-elem-transition" appear>
                <div className='form-header transition-delay'>
                    {passwordChange
                        ? "Please enter your username to change your password. You'll receive an email with instructions."
                        : "Please enter your username to reset your password. You'll receive an email with instructions."}
                    &nbsp;If you are experiencing problems with remembering your username, please contact us at
                    &nbsp;<a className='supp-link' href='mailto:helpdesk@r2net.com'>Helpdesk</a>.
                </div>
            </CSSTransition>
            <CSSTransition in={true} timeout={8500} classNames="form-elem-transition" appear>
                <CustomInput
                    inputRef={usernameRef}
                    handleChange={handleChange}
                    className='username-i transition-delay'
                    type='text'
                    label='Username'
                    name='username'
                    placeholder='Your Username'
                    value={userName}
                    handleBlur={handleBlur}
                    errors={errors}
                    touched={touched} />
            </CSSTransition>

            {message.text && (
                <div
                    className='message-container'
                    style={{
                        color: message.type === 'success' ? '#28a745' : '#dc3545',
                        marginTop: '10px',
                        fontSize: '14px',
                        textAlign: 'center'
                    }}
                >
                    {message.text}
                </div>
            )}

            <CSSTransition in={true} timeout={8500} classNames="form-elem-transition" appear>
                <div className='access-your-account-section transition-delay' style={{ textAlign: 'center', marginTop: '15px' }}>
                    <a
                        className='reset-link-txt'
                        href='#'
                        onClick={(e) => { e.preventDefault(); onBack && onBack(); }}
                    >
                        {passwordChange ? 'Back to login' : 'I remembered, let me login'}
                    </a>
                </div>
            </CSSTransition>

            <CSSTransition in={true} timeout={8500} classNames="form-elem-transition" appear>
                <div className='btn-container transition-delay'>
                    <DMSpinnerButton
                        onClick={onSendEmail}
                        className={`login-btn ${loading && 'disabled'}`}
                        text={loading ? '' : 'Send Email'}
                        type={'submit'}
                        disabled={loading || !userName}
                        transitionIn={loading}
                        transitionClassName={'login-anim'}
                        withTransition={true} />
                </div>
            </CSSTransition>
        </>
    );
};

export default ForgotPasswordForm;
